module.exports = __webpack_public_path__ + "static/media/mercado1.77840ec2.png";